export default __webpack_public_path__ + "static/media/myphoto.ded1e7ee.jpg";